import { InfoCircle } from '@/assets/icons'
import { kUploadDisclaimer } from '@/constants/constants-gcs'

export const UploadDisclaimer = () => (
  <div className="mt-1 flex items-center justify-center" aria-label="Upload Disclaimer">
    <InfoCircle className="text-brand-neutral-600 text-md mr-2" aria-label="Information icon" />
    <span className="text-xs text-brand-neutral-600 italic"> {kUploadDisclaimer}</span>
  </div>
)
